<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addLocationAndClasstypeDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="classTypeId" label="班级类型:">
          <el-select v-model="form.classTypeId" placeholder="选择班级类型">
            <el-option
              v-for="item in this.courseTypeList.courseTypeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item required prop="locationId" label="课程地点:">
          <el-select v-model="form.locationId" placeholder="选择课程地点">
            <el-option
              v-for="item in this.courseLocationList.courseLocationList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  addLocationAndClasstype,
  editLocationAndClasstype,
} from "@/api/locationAndClasstypeAndCoursepackage";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    return {
      isVisible: this.isShow,
      form: {
        id: "",
        locationId: "",
        classTypeId: "",
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    courseTypeList: Object,
    courseLocationList: Object,
  },
  computed: {
    ...mapGetters(["addLocationAndClasstypeDialog"]),
  },
  created() {},
  mounted() {
    if (this.addLocationAndClasstypeDialog.type === "edit") {
      this.form = this.dialogRow.param;
      console.log(this.form);
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addLocationAndClasstypeDialog.type === "edit") {
            editLocationAndClasstype(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                // const para = {
                //   userName: getToken("USERNAME"),
                //   content: "修改(" + this.form.packageName + ")课包类型操作",
                // };
                // addOperationRecord(para).then((res) => {
                //   console.log(res);
                // });
                this.isVisible = false;
                this.$emit("getLocationAndClasstype");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addLocationAndClasstype(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                // const para = {
                //   userName: getToken("USERNAME"),
                //   content: "新增(" + this.form.packageName + ")课包类型操作",
                // };
                // addOperationRecord(para).then((res) => {
                //   console.log(res);
                // });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getLocationAndClasstype");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
